export default "__VITE_ASSET__BhPnoNet__"